export const trackKlavioProductView = product => {
  const { location } = document;
  const { id, title, imageUrl, vendor, price, compareAtPrice, specs } = product;

  let categories = [];

  if (specs) {
    categories = specs?.items.reduce((result, spec) => {
      const searchedSpecs = ['Producttype', 'Productcategorie', 'Subcategorie'];
      const frenchSearchedSpecs = ['Type de produit', 'Catégorie de produit', 'Sous-catégorie'];
      const usSearchedSpecs = ['Product type', 'Product Category', 'Sub Category'];

      if (
        [...searchedSpecs, ...frenchSearchedSpecs, ...usSearchedSpecs].includes(
          spec.type.filterType
        )
      ) {
        result.push(spec.value);
      }
      return result;
    }, []);
  }

  const item = {
    ProductName: title,
    ProductID: id,
    Categories: categories,
    ImageURL: imageUrl,
    URL: `${location.href.split('?')[0]}`,
    Brand: vendor || 'Keune',
    Price: price,
    CompareAtPrice: compareAtPrice,
  };

  const track = () => {
    // eslint-disable-next-line no-underscore-dangle
    const klaviyo = window.klaviyo || [];
    klaviyo.push(['track', 'Viewed Product', item]);
    klaviyo.push([
      'trackViewedItem',
      {
        Title: item.ProductName,
        ItemId: item.ProductID,
        Categories: item.Categories,
        ImageUrl: item.ImageURL,
        Url: item.URL,
        Metadata: {
          Brand: item.Brand,
          Price: item.Price,
          CompareAtPrice: item.CompareAtPrice,
        },
      },
    ]);
  };

  try {
    // eslint-disable-next-line no-underscore-dangle
    if (typeof window !== 'undefined' && window.klaviyo) {
      track();
    } else {
      setTimeout(() => {
        // eslint-disable-next-line no-underscore-dangle
        if (typeof window !== 'undefined' && window.klaviyo) {
          track();
        }
      }, [process.env.GTM_DELAY]);
    }
  } catch (error) {
    console.error(error);
  }
};

export default trackKlavioProductView;
